import React from "react";
import { connect } from "react-redux";
import { notifyGeneralInfo } from "../../actions";
import axios from "axios";
import { withRouter } from "react-router-dom";
const token = localStorage.getItem('authToken');
class EditVratCategory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      textInput: "",
      userName: "",
      submissionStatus: null,
      currentImageUrl: null, 
      submeet: false,
      errors: [],
      maxSize: 5 * 1024 * 1024, // 5MB in bytes
      id: null,
      isLoading: true,
      imageUrl: "", // Added state for storing image URL
    };
  }

  async componentDidMount() {
    const { match } = this.props;
    if (match && match.params && match.params.id) {
      const { id } = match.params;
      this.setState({ id });
      await this.fetchData(id);
    } else {
      console.error("No match params found.");
    }
  }

  fetchData = async (id) => {
    console.log("Fetching data for ID:", id);
    try {
      const response = await axios.get(`https://samaj.aasmo.in/api/admin/vratcategory/${id}`,{
        headers: {
          Authorization: `Bearer ${token}`, 
        }
      });
      if (response) {
        console.log(response.data);
        this.setState({
          userName: response.data?.name || "",
          textInput: response.data?.image || "",
          imageUrl: response.data?.image || "", // Set image URL
          isLoading: false,
        });
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      this.setState({ isLoading: false });
    }
  };


  handleChange = (e) => {
    const files = Array.from(e.target.files);
    const errors = [];

    files.forEach((file) => {
      if (file.size > this.state.maxSize) {
        errors.push(`${file.name} is too large, please select a file smaller than 5MB.`);
      } else {
        this.setState({
          textInput: file,
          currentImageUrl: URL.createObjectURL(file), // Update current image URL to show the new image
        });
      }
    });

    this.setState({ errors });
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { id } = this.props.match.params;
    this.setState({ submeet: true });

    const { textInput, userName } = this.state;

    if (!textInput || !userName) {
      return;
    }

    try {
      const formData = new FormData();
      formData.append("image", textInput);
      formData.append("name", userName);

      const config = {
        headers: {
          'Content-Type': 'multipart/form-data',
        
            Authorization: `Bearer ${token}`, 
        
        }
      };

      const response = await axios.put(`https://samaj.aasmo.in/api/admin/vratcategory/${id}`, formData, config);

      if (response.status === 200) { 
        this.setState({ submissionStatus: 'success' });
        setTimeout(() => {
          this.props.history.push( "/vratAurTyoharcategory");
        }, 2000);
      }
  
      console.log(response, "==>res");
    } catch (error) {
      console.log(error);
    }
  };

  render() {
    const { textInput, userName,currentImageUrl, submeet, submissionStatus, isLoading, imageUrl } = this.state;
    const isNameValid = userName.trim().length > 0;

    if (isLoading) {
      return <div>Loading...</div>;
    }

    return (
      <div className="col-md-12">
        <div className="card">
          <div className="header">
            <h2>Edit Vrat Aur Tyohar Category</h2>
          </div>
          <div className="body">
            <form onSubmit={this.handleSubmit}>
            <div className="form-group">
                <label>Category Image</label>
               
                {currentImageUrl && (
                  <div>
                    <img src={currentImageUrl} alt="Current" style={{ width: '100px', marginBottom: '10px' }} />
                  </div>
                )}
                <input
                  type="file"
                  className={`form-control ${!textInput && submeet && "parsley-error"}`}
                  name="textInput"
                  required=""
                  onChange={this.handleChange}
                />
                {!textInput && submeet ? (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                ) : null}
              </div>

              <div className="form-group">
                <label>Category Name</label>
                <input
                  className={`form-control ${!isNameValid && submeet && "parsley-error"}`}
                  value={userName}
                  name="userName"
                  required=""
                  type="text"
                  onChange={(e) => {
                    this.setState({ userName: e.target.value });
                  }}
                />
                {!isNameValid && submeet && (
                  <ul className="parsley-errors-list filled">
                    <li className="parsley-required">This value is required.</li>
                  </ul>
                )}
              </div>

              {submissionStatus === "success" && (
                <div className="alert alert-success" role="alert">
                  Form submitted successfully!
                </div>
              )}

              <button className="btn btn-primary" type="submit">
                Submit
              </button>
            </form>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = ({ mailInboxReducer }) => ({});

export default connect(mapStateToProps, { notifyGeneralInfo })(withRouter(EditVratCategory));
